'use client';

import { ReactNode, useEffect, useRef, useState } from 'react';
import { usePrivate } from '@/components/private';
import {
  abortAllPendingGraphQL,
  createApolloClient,
} from '@/studbook/apolloClient';
import { ApolloClient, ApolloProvider } from '@apollo/client';
import SplashScreen from '@/components/splashScreen/SplashScreen';

function GraphQLProvider({ children }: { children: ReactNode | ReactNode[] }) {
  const { token: accessToken, refreshToken } = usePrivate();
  const previousAccessToken = useRef('');
  const [apolloClient, setApolloClient] = useState<ApolloClient<any> | null>(
    null,
  );

  useEffect(() => {
    if (!apolloClient && previousAccessToken.current !== accessToken) {
      abortAllPendingGraphQL();
      previousAccessToken.current = accessToken || '';

      const client = createApolloClient({
        token: accessToken || '',
        refreshToken,
        onTokenRefresh: (newToken, newRefreshToken) => {
          // Recreate Apollo client with new tokens
          const newClient = createApolloClient({
            token: newToken,
            refreshToken: newRefreshToken,
            onTokenRefresh: () => {}, // TODO: Will be replaced when recreating
          });
          if (newClient) {
            setApolloClient(newClient);
          }
        },
      });

      if (client) {
        setApolloClient(client);
      }
    }
    apolloClient && apolloClient.reFetchObservableQueries();
  }, [accessToken, refreshToken, apolloClient]);

  if (!apolloClient) return <SplashScreen />;

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
}

export default GraphQLProvider;
